import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersOpenFolderOnTicketReply = createBasicSelector(
  state => selectBooleanPreferenceByName(state, 'open_folder_on_ticket_reply')
)
